export default "__VITE_ASSET__D3Jn$vBB__"